module.exports = __webpack_public_path__ + "static/img/axb.e03acb37.png";